<app-tables
  [tableHeader]="tableHeader"
  [footerText]="footerText"
  [url]="url"
  [columns]="columns"
  [filters]="filters"
  [columnWidths]="columnWidths"
  [type]="'invoiceList'"
></app-tables>



<!-- (filtersChange)="filterInvoiceList($event.filters, $event.sort)"
(onPageChange)="onPageChange($event)"
(onPageSizeChange)="onPageSizeChange($event)"
[tableLoading]="invoiceListLoading"
[totalPage]="totalPage"
[pageSize]="pageSize"
(handleGetConsultationList)="getInvoiceList(1, pageSize, filters)"
[data]="invoiceList"
[totalCount]="totalInvoice" -->
